export default "__VITE_ASSET__D3LFUn$L__"